import React from 'react'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import useIsMobile from 'components/program-marketing/useIsMobile'

const useStyles = makeStyles(theme => ({
  wrapper: {
    [theme.breakpoints.up('md')]: {
      position: 'absolute',
      right: theme.spacing(14),
      top: 186,
      height: 'calc(80% - 186px)',
      width: 'calc((100% / 3) - 8em)',
      zIndex: 1,
      marginTop: 'auto',
    },
    marginTop: '-64px',
  },
}))

const RegistrationFloating = ({ children, started }) => {
  const isMobile = useIsMobile()
  const classes = useStyles()
  const px = isMobile ? 4 : 16
  const pb = isMobile ? 10 : 0
  const gridMargin = isMobile ? { margin: 'auto' } : null
  return (
    <Box px={px} pb={pb}>
      <Grid container justify="flex-end" direction="row" spacing={8}>
        <Grid item md={4} sm={12} style={gridMargin}>
          <Box flexGrow={1} className={classes.wrapper}>
            {children}
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default RegistrationFloating
